module.exports = __webpack_public_path__ + "img/pie-chart.91d564b5.svg";